"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'home_seckill',
  cname: '秒杀',
  icon: 't-icon-zujian-miaosha',
  configName: 'c_home_seckill',
  type: 1,
  defaultName: 'seckill',
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mediaDomain'])), {}, {
    outerStyle: function outerStyle() {
      var bgColors = this.configObj.bgColor && this.configObj.bgColor.color;
      var bg = bgColors ? "linear-gradient(to right, ".concat(bgColors[0].item, ", ").concat(bgColors[1].item, ")") : 'linear-gradient(to right, #FF2200, #FFFFFF)';
      return [{
        'border-radius': (this.configObj.bgStyle ? this.configObj.bgStyle.val : 7) + 'px'
      }, {
        margin: (this.configObj.mbConfig ? this.configObj.mbConfig.val : 10) + 'px ' + (this.configObj.lrConfig ? this.configObj.lrConfig.val : 12) + 'px 0'
      }, {
        padding: (this.configObj.upConfig ? this.configObj.upConfig.val : 10) + 'px 10px ' + (this.configObj.downConfig ? this.configObj.downConfig.val : 10) + 'px'
      }, {
        background: bg
      }];
    },
    contentBoxStyle: function contentBoxStyle() {
      return {
        'border-radius': (this.configObj.contentStyle ? this.configObj.contentStyle.val : 5) + 'px'
      };
    },
    productImgStyle: function productImgStyle() {
      return {
        'border-radius': (this.configObj.contentStyle ? this.configObj.contentStyle.val : 5) + 'px'
      };
    },
    titleColorVal: function titleColorVal() {
      return this.configObj.titleColor && this.configObj.titleColor.color ? this.configObj.titleColor.color[0].item : '#fff';
    },
    nameColorVal: function nameColorVal() {
      return this.configObj.nameColor && this.configObj.nameColor.color ? this.configObj.nameColor.color[0].item : '#282828';
    },
    priceColorVal: function priceColorVal() {
      return this.configObj.priceColor && this.configObj.priceColor.color ? this.configObj.priceColor.color[0].item : '#E93323';
    },
    bannerSrc: function bannerSrc() {
      if (this.configObj.bannerConfig && this.configObj.bannerConfig.url) {
        return this.configObj.bannerConfig.url;
      }
      return this.configObj.logoConfig && this.configObj.logoConfig.url ? this.configObj.logoConfig.url : (localStorage.getItem('mediaDomain') || '') + '/crmebimage/presets/seckillTitle.png';
    },
    titleText: function titleText() {
      return this.configObj.titleConfig && this.configObj.titleConfig.val ? this.configObj.titleConfig.val : '';
    },
    _getActiveValues: function _getActiveValues() {
      var pc = this.configObj.progressConfig && this.configObj.progressConfig.activeValue;
      var tc = this.configObj.typeConfig && this.configObj.typeConfig.activeValue;
      if (pc) return pc;
      if (tc) return tc;
      return null;
    },
    nameShow: function nameShow() {
      var active = this._getActiveValues;
      var hasConfig = this.configObj.progressConfig || this.configObj.typeConfig;
      return !hasConfig || active && active.indexOf(0) !== -1;
    },
    priceShow: function priceShow() {
      var active = this._getActiveValues;
      var hasConfig = this.configObj.progressConfig || this.configObj.typeConfig;
      return !hasConfig || active && active.indexOf(1) !== -1;
    },
    progressShow: function progressShow() {
      var active = this._getActiveValues;
      return !this.configObj.progressConfig || active && active.indexOf(2) !== -1;
    },
    originalPriceShow: function originalPriceShow() {
      var active = this._getActiveValues;
      return !this.configObj.progressConfig || active && active.indexOf(3) !== -1;
    }
  }),
  watch: {
    num: function num(nVal) {
      var data = this.$store.state.mobildConfig.defaultArray[nVal];
      this.setConfig(data);
    },
    defaultArray: {
      handler: function handler() {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'seckill',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '秒杀'
        },
        tabConfig: {
          title: '展示样式',
          tabTitle: '布局设置',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '样式1',
            icon: 'icon-yangshiyi'
          }, {
            val: '样式2',
            icon: 'icon-yangshier'
          }]
        },
        logoConfig: {
          isShow: 1,
          tabTitle: '图标设置',
          title: '上传图标',
          tips: '建议：124px*32px',
          url: localStorage.getItem('mediaDomain') + '/crmebimage/presets/seckillTitle.png'
        },
        bannerConfig: {
          isShow: 1,
          tabTitle: '横幅设置',
          title: '左侧横幅图',
          tips: '建议：200px*200px',
          url: ''
        },
        titleConfig: {
          tabTitle: '标题设置',
          title: '标题内容',
          val: '限时秒杀',
          place: '请输入标题',
          isShow: 1,
          max: 15
        },
        linkConfig: {
          title: '更多链接',
          val: '/pages/activity/goods_seckill/index',
          place: '请选择链接',
          isShow: 1,
          max: 100
        },
        countdownConfig: {
          tabTitle: '倒计时设置',
          title: '显示倒计时',
          isShow: 1
        },
        typeConfig: {
          tabTitle: '显示内容',
          name: 'rowsNum',
          title: '基础信息',
          activeValue: [0, 1],
          list: [{
            val: '商品名称'
          }, {
            val: '商品价格'
          }]
        },
        progressConfig: {
          tabTitle: '显示内容',
          name: 'progressConfig',
          title: '展示信息',
          activeValue: [0, 1, 2, 3],
          list: [{
            val: '商品名称'
          }, {
            val: '商品价格'
          }, {
            val: '已抢进度'
          }, {
            val: '原价'
          }]
        },
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          color: [{
            item: '#FF2200'
          }, {
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FF2200'
          }, {
            item: '#FFFFFF'
          }]
        },
        nameColor: {
          title: '商品名称颜色',
          color: [{
            item: '#282828'
          }],
          default: [{
            item: '#282828'
          }]
        },
        titleColor: {
          title: '标题颜色',
          color: [{
            item: '#fff'
          }],
          default: [{
            item: '#fff'
          }]
        },
        priceColor: {
          title: '价格颜色',
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 7,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '内容圆角',
          name: 'contentStyle',
          val: 5,
          min: 0,
          max: 30
        },
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        },
        contentConfig: {
          title: '内容间距',
          val: 10,
          min: 0,
          max: 30
        }
      },
      configObj: null,
      spikeList: [{
        image: '',
        name: '秒杀商品示例',
        seckillPrice: '198',
        price: '398',
        payRange: '65%'
      }, {
        image: '',
        name: '秒杀商品示例',
        seckillPrice: '198',
        price: '398',
        payRange: '65%'
      }, {
        image: '',
        name: '秒杀商品示例',
        seckillPrice: '198',
        price: '398',
        payRange: '65%'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      this.configObj = data;
    },
    progressWidth: function progressWidth(payRange) {
      if (!payRange) return {
        width: '0%'
      };
      var num = parseFloat(payRange);
      return {
        width: (isNaN(num) ? 0 : num) + '%'
      };
    }
  }
};